import * as React from 'react';
import { LocalizedDateTime, DateTimeAccuracy } from '../../misc/components/LocalizedDateTime';
import { DcfRequestStatusEnum } from '../../misc/api/apiTypes';

interface ReviewItemProps {
    currentRequestStatus: DcfRequestStatusEnum;
    username: string;
    datetime: string;
    reason: string;
    stepApproved: boolean;
    title: string;
}

enum StatusClasses {
    Approved = "success",
    Rejected = "danger",
    Pending = "warning"
}

enum StatusLabels {
    Approved = "Approved",
    Rejected = "Rejected",
    Pending = "Pending"
}

const getBadgeClassName = (isApproved: boolean): string => {
    return getBadgeClass(isApproved ? StatusClasses.Approved : StatusClasses.Rejected)
}

const getBadgeClass = (status: StatusClasses) => {
    return "label label-" + status;
}

const isSkipped = (status: DcfRequestStatusEnum, user: string) => !user && status === DcfRequestStatusEnum.Rejected;

const getStatusBadge = (id: string, status: DcfRequestStatusEnum, approved: boolean, user: string) => {

    if (isSkipped(status, user)) {
        return null;
    }

    if (!user) {
        return <label id={`ReviewStatus${id}`} className={getBadgeClass(StatusClasses.Pending)}>{StatusLabels.Pending}</label>
    }

    return (
        user && <label id={`ReviewStatus${id}`} className={getBadgeClassName(approved)}>{approved ? StatusLabels.Approved : StatusLabels.Rejected}</label>
    );
}

export const ReviewItem = ({ currentRequestStatus, username, datetime, reason, stepApproved, title }: ReviewItemProps) => {
    const id = title.replace(/\s/g, "");

    return (<div className="row">
        <div className="col-sm-3">
            <h4>{title}</h4>
        </div>
        <div className="col-sm-9">
            {getStatusBadge(id, currentRequestStatus, stepApproved, username)}
        </div>
        <div className="col-sm-12">
            {!isSkipped(currentRequestStatus, username) && username ? <blockquote>
                <p id={`ReviewReason${id}`}>{reason}</p>
                <footer>{username} at <LocalizedDateTime time={datetime} accuracy={DateTimeAccuracy.Second} isTooltip={true} /></footer>
            </blockquote> : <span>N/A</span>}
        </div>
    </div>)
}
